import {createContext} from 'react';

const WorkspacesContext = createContext(null);

export default WorkspacesContext;
